export enum ButtonTheme {
  MenuFilter = `menu-filter`,
  Primary = `primary`,
  // Used on the discover page. It forces the font size to medium size, independent of the button size, and also adds gray background and no borders.
  Browse = `browse`,
  Secondary = `secondary`,
  Tertiary = `tertiary`,
  Lightweight = `lightweight`,
  Select = `select`,
  QbSubitem = `qb-subitem`,
  QueryBuilder = `query-builder`,
  MenuFooter = `menu-footer`,
  MarketingPrimary = `marketing-primary`,
  MarketingSecondary = `marketing-secondary`,
  TemplatesEvent = `templates-event`,
  Upgrade = `upgrade`,
  WarningActions = `warning-actions`,
  Spark = `spark`,
  Chip = `chip`,
}

export enum ButtonSize {
  Inline = `inline`,
  Tiny = `tiny`,
  Small = `small`,
  SmallIcon = `small-icon`,
  Medium = `medium`,
  Large = `large`,
}

export enum ButtonType {
  Base = `base`,
  Destructive = `destructive`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
  Marketing = `marketing`,
}

export enum ButtonLayout {
  Horizontal = `horizontal`,
  Vertical = `vertical`,
}

/**
 * Class on the element that carries the button's theme, size, and state, under both the Panel and
 * React implementations, so consumer CSS and tests can target either through the same selectors.
 */
export const BUTTON_ROOT_CLASS = `mp-button-root`;

/** Class on the element that wraps the button's caller-provided content. */
export const BUTTON_CONTENT_TEXT_CLASS = `mp-button-content-text`;
